// NOTE: for type annotation only; do not use for anything else
import { BuiltinSimulatorHost } from '@rchh/lowcode-designer';

export const host: BuiltinSimulatorHost = (window as any).LCSimulatorHost;
